<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error
      size="md"
      v-else-if="error"
      :state="state"
    >Невозможно восстановить пароль. Ссылка не действительна.</vis-error>
    <div v-else class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-content-start">
      <h4
        class="ba-w-full ba-text-xl md:ba-text-2xl ba-mb-4 xs:ba-mb-6 ba-text-center ba-text-white"
      >Восстановление пароля</h4>
      <p
        v-if="false"
        class="ba-text-center ba-text-sm ba-mb-4 sm:ba-mb-10"
      >Описание</p>
      <p v-if="userEmail" class="ba-text-center ba-text-sm ba-mb-4 ba-w-full ba-text-white">
        <span class="far fa-user ba-text-sm ba-mb-1 ba-mr-1" />
        <span>{{ userEmail }}</span>
      </p>
      <form
        @submit.prevent="resetPasswordFormSubmit"
        class="ba-w-full ba-flex ba-flex-wrap ba-justify-center ba-max-w-xs ba-relative ba-pt-4"
      >
        <p
          v-if="formError"
          class="error form-message ba-text-center ba-text-sm"
        >Не удалось изменить пароль</p>
        <p
          v-if="formSuccess"
          class="success form-message ba-text-center ba-text-sm"
        >Пароль успешно изменен. Вернитесь на форму авторизации и войдите снова.</p>
        <p
          v-if="formFieldsRequired"
          class="error form-message ba-text-center ba-text-sm"
        >Все поля обязательны для заполнения</p>
        <p
          v-if="formInvalidComparePassword"
          class="error form-message ba-text-center ba-text-sm"
        >Указанные пароли не совпадают</p>
        <vis-form-input
          v-model="form.password"
          :disabled="formLoading"
          label="Новый пароль"
          type="password"
          icon="fas fa-unlock-alt"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.repeatPassword"
          :disabled="formLoading"
          label="Подтверждение пароля"
          type="password"
          icon="fas fa-unlock-alt"
          autocomplete="off"
        />
        <button
          type="submit"
          :disabled="formLoading"
          class="btn ba-w-full ba-max-w-xs btn--login"
        >Изменить пароль</button>
      </form>
      <router-link
        :to="{ name: 'login', query: { state } }"
        class="forgot ba-block ba-text-center ba-w-full"
      >
        <span>Вернуться к авторизации</span>
      </router-link>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import { resetPasswordMixin } from "@ba/visary-account-common-vue";

export default {
  name: "vis-page-reset-password",
  components: {
    VisLoginLayout
  },
  mixins: [resetPasswordMixin]
};
</script>
